import { Button, Space, Descriptions } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import { getDetail2 } from '@/api/recall';
import { useRequest } from 'ahooks';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { PublishStatusMap, RewardTypeEnumMap, UserEnum } from './type';

const RecallEmailDetail = () => {
  const { id } = useParams();

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data, run } = useRequest(
    (id) => getDetail2({ recallEmailId: Number(id) }),
    {
      manual: true,
    }
  );

  const detail = useMemo(() => {
    if (!data) return;
    return data.data.data;
  }, [data]);

  useEffect(() => {
    if (!id) return;
    run(id);
  }, [id]);

  const navigator = useNavigate();

  function onCancel() {
    navigator(-1);
  }

  return (
    <div>
      <Descriptions>
        <Descriptions.Item label="推送对象" span={24}>
          {detail && UserEnum[detail.pushTargetType]}
        </Descriptions.Item>
        <Descriptions.Item label="推送标题" span={24}>
          {detail?.title}
        </Descriptions.Item>
        <Descriptions.Item label="正文" span={24}>
          <div
            dangerouslySetInnerHTML={{ __html: detail?.content ?? '' }}
          ></div>
        </Descriptions.Item>
        <Descriptions.Item label="推送时间（日本时间）" span={24}>
          {detail?.publishTime}
        </Descriptions.Item>
        <Descriptions.Item label="召回奖励" span={24}>
          {detail?.rewardType && `${RewardTypeEnumMap.get(detail.rewardType)} ${detail.rewardCoins}枚`}
        </Descriptions.Item>
        <Descriptions.Item label="推送状态" span={24}>
          {detail && PublishStatusMap.get(detail.publishStatus)}
        </Descriptions.Item>
        <Descriptions.Item label="操作人员" span={24}>
          {detail?.publishUser}
        </Descriptions.Item>
      </Descriptions>
      <Space style={{ width: '100%', justifyContent: 'center' }}>
        <Button onClick={onCancel}>返回</Button>
      </Space>
    </div>
  );
};

export default RecallEmailDetail;
